export const LLM_MODEL_REGIONS = {
  CH: 'ch',
  EU: 'eu',
  GLOBAL: 'global',
} as const;

export type LlmModelRegion =
  typeof LLM_MODEL_REGIONS[keyof typeof LLM_MODEL_REGIONS];

export const LLM_MODEL_PROVIDER_LABELS = {
  AZURE: 'Azure',
  OPENAI: 'OpenAI',
  ANTHROPIC: 'Anthropic',
  GOOGLE: 'Google',
  MISTRAL: 'Mistral',
  META: 'Meta',
  SELISE_AI: 'SeliseAI',
} as const;

export type LlmModelProviderLabel =
  typeof LLM_MODEL_PROVIDER_LABELS[keyof typeof LLM_MODEL_PROVIDER_LABELS];
